import 'regenerator-runtime/runtime'
import customSelect from 'custom-select'
import scrollToElement from './modules/scrollToElement'
// import numberCounter from './modules/counter'
import fixedNavbar from './modules/fixedNavbar'
import amazingScroll from './modules/amazingScroll'
import amazingScrollSlider from './modules/amazingScrollSlider'

import './modules/accordion'
import './modules/tabs'

var animationList = {
	'fade-top': 'top:-100px->0; transition:all 0s->all 1s; opacity:0->1;',
	'fade-right': 'opacity: 0->1; right:-500px->0; transition:all 0s->all 1s',
	'fade-bottom': 'bottom:-100px->0; transition:all 1s; opacity:0->1;',
	'fade-left': 'opacity: 0->1; left:-500px->0; transition:all 0s->all 1s',
	'fade-left-top': 'opacity: 0->1; left:-50px->0; top:-50px->0; transition:all 0s->all 1s',
	'fade-left-bottom': 'opacity: 0->1; left:-50px->0; bottom:-50px->0; transition:all 0s->all 1s',
	'opacity': 'opacity: 0->1; transition:all 0s->all 1s',
	'enlarge': 'transform:scale(0.5)->scale(1); opacity: 0->1; transition:all 0s->all 1s',
	'shrink': 'transform:scale(1)->scale(0.5); opacity: 0->1; transition:all 0s->all 1s',
	'rotate': 'transform:scale(0) rotate(-720deg)->scale(1) rotate(0deg); opacity: 0->1; transition:all 0s->all 1s'
}

document.addEventListener('DOMContentLoaded', function () {
	// Karuzele Bootstrap
	const Carousel = require('./modules/carousel.js').default
	const carousels = [...document.querySelectorAll('.carousel')]

	const main_slider = document.querySelectorAll('.carousel-indicators > li')

	main_slider.forEach

	if (carousels.length) {
		carousels.forEach(node => {
			if (node.id !== 'slider-157') {
				const slider = new Carousel(node)
			}
		})
	}

	// Akordiony Bootstrap
	const Collapse = require('./modules/collapse.js').default
	const collapses = [...document.querySelectorAll('[data-toggle="collapse"]')]
	if (collapses.length) {
		collapses.forEach(node => new Collapse(node))
	}
	// Własne selecty
	customSelect('select.custom-select')

	scrollToElement(document.querySelector('nav.navbar').offsetHeight)
	// Licznik wyłączony
	// numberCounter()

	if (window.innerWidth >= 1200) {
		window.animate = amazingScroll({
			start: {
				visibleAfterLoading: true,
				waitForScroll: {
					on: false,
					ratio: 0
				}
			},
			animation: animationList
		})

		const selectors = ['.carousel']
		selectors.forEach(selector => {
			amazingScrollSlider(selector, animationList)
		})
	}

	// fixedNavbar()

	const addSlider = () => {
		carousels.forEach(node => {
			node.id === 'slider-157' ? new Carousel(node) : ''
		})
	}

	if (window.innerWidth >= 1200) {
		addSlider()
	}

	const squad_buttons = document.querySelectorAll('#squad')

	const scrollToSquadContent = (btns) => {
		btns.forEach(btn => {
			btn.addEventListener('click', () => {
				if (window.innerWidth <= 767) {
					window.scrollTo({
						left: 0,
						top: 610,
						behavior: 'smooth'
					})
				}
			})
		})
	}

	window.addEventListener('resize', () => {
		if (window.innerWidth >= 1200) {
			addSlider()
		}

		scrollToSquadContent(squad_buttons)
	})

	scrollToSquadContent(squad_buttons)

	const overlays = document.querySelectorAll('.overlay-content')

	overlays.forEach(overlay => overlay.addEventListener('touchstart', () => overlay.classList.add('overlay-content--active')))

	let options = {}

	const tables = document.querySelectorAll('.overlay-content')

	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if (entry.target.classList.contains('overlay-content--active')) {
				entry.target.classList.remove('overlay-content--active')
			}
		})
	}, options)

	tables.forEach(table => {
		observer.observe(table)
	})
})



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/script.js